export default  {
  name: 'purchaseList',
  bindings: {
    purchase: '<'
  },
  controller: ['$state',
    class {
      constructor($state) {
        this.$state = $state;
        this.productoAmpliar = null;
        this.visibleModal = false;
      }

      hacerPedido() {
        this.$state.go('purchaseConfirm');
      }

      closeModal() {
        this.visibleModal = false;

        // const modal = document.getElementById('unaModal2');
        // let elementsByTagName = document.getElementsByTagName('body');
        // elementsByTagName[0].classList.remove('mostrando-modal');
        // modal.style.display = "none";
      }

      toggleDescModal(producto) {
        this.productoAmpliar = producto;
        this.visibleModal = !this.visibleModal;
      }
    }
  ],
  templateUrl: '/template/render/?tpl=/oferta-navidad/purchaseList.php'
};


// WEBPACK FOOTER //
// ./oferta-navidad/purchaseListComponent.js